import { useContext } from 'react';
import { VersionControlContext } from './VersionControlProvider';

export function useVersionControlStore() {
  return useContext(VersionControlContext);
}
